export default function ({ $config, error }) {
  if (!$config.hasAccount) {
    error({ statusCode: 404, message: 'Page not found' })
  }
}
